import { DetailedHTMLProps, FC, HTMLAttributes } from 'react'

type Props = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

const QueueNodeDragHandle: FC<Props> = (props) => {
  return (
    <div
      className="p-3 d-flex align-items-center"
      {...props}
    >
      <i className="fas fa-bars fs-4" />
    </div>
  )
}

export { QueueNodeDragHandle }
